/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import AutoRenewMembershipOption from "./AutoRenewMembershipOption";
import { getOptionalRecurringMembershipForItem } from "../../utils/helpers/membership";

// SummaryItemsTable `renderLineExtra` slot: inline auto-renew opt-in under optional
// recurring rows. Returns undefined when opt-in doesn't apply (no extra row rendered).
export const buildAutoRenewLineExtra = ({ invoice, autoRenew, onAutoRenewChange, enabled }) => {
  if (!enabled) return undefined;

  return (item) => {
    const info = getOptionalRecurringMembershipForItem(invoice, item);
    if (!info) return null;

    return <AutoRenewMembershipOption {...info} checked={autoRenew} onChange={onAutoRenewChange} />;
  };
};
